import React from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  FormGroup,
  SelectableCardsGrid,
  SelectableCard,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";

const GESTION_OPTIONS = [
  {
    id: "papel",
    icon: "📝",
    title: "Documentación en papel",
    desc: "Historias clínicas físicas y cuaderno",
  },
  {
    id: "digital_basico",
    icon: "📊",
    title: "Herramientas digitales",
    desc: "Excel, Google Calendar y WhatsApp",
  },
  {
    id: "software",
    icon: "💻",
    title: "Software especializado",
    desc: "Programa de salud o facturación previo",
  },
];

export const StepDiagnosisGestion = ({
  formData,
  setFormData,
  onNext,
  onBack,
}) => {
  const isSelected = Boolean(formData.gestionActual);

  return (
    <StepCard>
      <StepTitle>¿Cómo gestionas tu consultorio hoy?</StepTitle>
      <StepSubtitle>
        Esta última pregunta nos ayuda a entender cómo podemos simplificar tu día a día.
      </StepSubtitle>

      <FormGroup>
        <SelectableCardsGrid columns={3}>
          {GESTION_OPTIONS.map((opt) => {
            const selected = formData.gestionActual === opt.id;
            return (
              <SelectableCard
                key={opt.id}
                selected={selected}
                onClick={() => {
                  setFormData({ ...formData, gestionActual: opt.id });
                  onNext("gestionActual", opt.id);
                }}
              >
                <div className="icon-wrapper">{opt.icon}</div>
                <h4 className="card-title">{opt.title}</h4>
                <p className="card-description">{opt.desc}</p>
              </SelectableCard>
            );
          })}
        </SelectableCardsGrid>
      </FormGroup>

      <NavigationButtonsRow>
        <ActionButton type="button" onClick={onBack}>
          ← Atrás
        </ActionButton>
      </NavigationButtonsRow>
    </StepCard>
  );
};
